import { DashboardChecksTypeEnum } from "@payping/api";
import { useAppSelector } from "@/utils";

export function useBusinessDisabled() {
  const checks = useAppSelector((state) => state.user.checks);

  // TODO: this logic should be checked in backend and included inside checks.businessStatus (remove this section when new User service is launched)
  return checks?.businessStatus === DashboardChecksTypeEnum.Confirmed;
}
